<template>
  <footer class="rodape">
    <div class="conteudo rodape__grade">
      <section class="rodape__marca">
        <MarcaLogo tema="escuro" :tamanho="44" />
        <p class="rodape__descricao">
          Todo o comércio da sua cidade, conectado em um lugar só.
        </p>
      </section>

      <ColunaDoRodape
        v-for="coluna in COLUNAS"
        :key="coluna.id"
        :identificador="coluna.id"
        :titulo="coluna.titulo"
        :itens="coluna.itens"
        :aberta="colunaAberta === coluna.id"
        @alternar="alternarColuna"
      />

      <section class="lojista">
        <h2 class="lojista__titulo">É lojista?</h2>
        <p class="lojista__texto">Gerencie seus pedidos no</p>
        <a :href="PORTAL_ADM" class="lojista__botao" target="_blank" rel="noopener noreferrer">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <rect x="3" y="4.5" width="18" height="15" rx="2.4" />
            <path d="M3 9.2h18M7 13.4h5" />
          </svg>
          <span>
            <small>Acesse o</small>
            <strong>Portal ADM</strong>
          </span>
        </a>
      </section>

      <!--
        Fica por ultimo na grade: no mobile empilha abaixo do Portal ADM; no
        desktop e posicionado na coluna 1, linha 2, sob a marca e a descricao.
      -->
      <div class="rodape__apoio-linha" @contextmenu.prevent @dragstart.prevent>
        <div class="rodape__apoio">
          <span class="rodape__apoio-rotulo">Apoio</span>
          <ul class="rodape__apoio-marcas">
            <li v-for="marca in APOIO" :key="marca.chave" :class="`rodape__apoio-item--${marca.chave}`">
              <img :src="marca.imagem" :alt="marca.nome" loading="lazy" draggable="false">
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="conteudo rodape__base">
      <p>© {{ ano }} crescimento conectado. Todos os direitos reservados.</p>
    </div>
  </footer>
</template>

<script setup>
  import { ref } from 'vue';
  import MarcaLogo from '@/components/marketplace/MarcaLogo.vue';
  import ColunaDoRodape from '@/components/marketplace/ColunaDoRodape.vue';

  const PORTAL_ADM = 'https://app.crescimentoconectado.com.br/admin_crescc';

  /*
   * Privacidade e termos reaproveitam os modais ja montados em App.vue, abertos
   * pelo Bootstrap via data-toggle, como nas demais telas da plataforma.
   */
  const COLUNAS = [
    {
      id: 'navegar',
      titulo: 'Navegar',
      itens: [
        { rotulo: 'Início', destino: '#', atributos: {} },
        { rotulo: 'Categorias', destino: '#categorias', atributos: {} },
        { rotulo: 'Lojas', destino: '#lojas', atributos: {} }
      ]
    },
    {
      id: 'termos',
      titulo: 'Termos',
      itens: [
        {
          rotulo: 'Política de Privacidade',
          destino: '#',
          atributos: { 'data-toggle': 'modal', 'data-target': '#modalPrivacidade' }
        },
        {
          rotulo: 'Termos de uso',
          destino: '#',
          atributos: { 'data-toggle': 'modal', 'data-target': '#modalTermos' }
        }
      ]
    }
  ];

  /* Logos de apoio institucional, exibidos sobre fundo claro no fim do rodape. */
  const APOIO = [
    { chave: 'fapesq', nome: 'FapesQ-PB', imagem: 'assets/img/apoio/fapesq.png' },
    { chave: 'tecnova', nome: 'Tecnova III', imagem: 'assets/img/apoio/tecnova.png' },
    { chave: 'finep', nome: 'Finep', imagem: 'assets/img/apoio/finep.png' },
    { chave: 'governo', nome: 'Governo da Paraíba', imagem: 'assets/img/apoio/governopb.png' }
  ];

  const ano = new Date().getFullYear();
  const colunaAberta = ref('');

  function alternarColuna(id) {
    colunaAberta.value = colunaAberta.value === id ? '' : id;
  }
</script>

<style scoped>
  .rodape {
    margin-top: var(--espaco-7);
    position: relative;
    isolation: isolate;
    overflow: hidden;
    color: rgba(255, 255, 255, 0.82);
    background: linear-gradient(163deg, #d8403d, #d13a37, #ca3431, #c32e2c, #bc2926, #b52422 45%, #ae211f 55%, #a71e1c, #a01b19, #991817, #921615, #8b1413);
  }

  .rodape::before {
    content: "";
    position: absolute;
    inset: 0;
    z-index: -1;
    background: radial-gradient(120% 90% at 10% -12%, rgba(255, 255, 255, 0.14) 0%, transparent 58%),
      radial-gradient(90% 70% at 94% 110%, rgba(88, 8, 8, 0.32) 0%, transparent 62%);
    pointer-events: none;
  }

  .rodape::after {
    content: "";
    position: absolute;
    inset: 0;
    z-index: -1;
    opacity: 0.45;
    mix-blend-mode: overlay;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='140' height='140'%3E%3Cfilter id='r'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.85' numOctaves='3'/%3E%3C/filter%3E%3Crect width='140' height='140' filter='url(%23r)' opacity='.4'/%3E%3C/svg%3E");
    pointer-events: none;
  }

  .rodape__grade {
    display: grid;
    gap: var(--espaco-2);
    padding-block: var(--espaco-5) var(--espaco-4);
  }

  .rodape__descricao {
    margin: var(--espaco-3) 0;
    max-width: 34ch;
    font-size: 0.88rem;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.78);
  }

  .lojista {
    border-top: 1px solid rgba(255, 255, 255, 0.16);
    padding-top: var(--espaco-3);
    padding-bottom: var(--espaco-2);
  }

  .lojista__titulo {
    margin: 0;
    font-family: var(--fonte-titulo);
    font-size: 1rem;
    font-weight: 700;
    color: #fff;
  }

  .lojista__texto {
    margin: var(--espaco-1) 0 var(--espaco-3);
    font-size: 0.86rem;
    color: rgba(255, 255, 255, 0.78);
  }

  .lojista__botao {
    display: inline-flex;
    align-items: center;
    gap: var(--espaco-3);
    padding: var(--espaco-3) var(--espaco-4);
    border-radius: var(--raio-medio);
    background: rgba(255, 255, 255, 0.12);
    border: 1px solid rgba(255, 255, 255, 0.26);
    color: #fff;
    transition: background var(--transicao-padrao), color var(--transicao-padrao);
  }

  .lojista__botao:hover {
    background: #fff;
    color: var(--cor-marca);
  }

  .lojista__botao small {
    display: block;
    font-size: 0.66rem;
    opacity: 0.8;
  }

  .lojista__botao strong {
    display: block;
    font-size: 1rem;
  }

  .rodape__base {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--espaco-3);
    padding-block: var(--espaco-3);
    border-top: 1px solid rgba(255, 255, 255, 0.16);
    text-align: center;
  }

  .rodape__base p {
    margin: 0;
    font-size: 0.78rem;
    color: rgba(255, 255, 255, 0.62);
  }

  /*
   * Faixa de apoio compacta: uma caixa pequena, centralizada no mobile e
   * alinhada a direita no desktop. Os logos tem cor e tinta escura, entao
   * ficam sobre fundo claro para serem lidos.
   */
  .rodape__apoio-linha {
    display: flex;
    justify-content: center;
  }

  /* Uma linha so (mobile e desktop) deixa o card fino; pouco arredondado. */
  .rodape__apoio {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    gap: var(--espaco-2) var(--espaco-3);
    padding: var(--espaco-2) var(--espaco-3);
    border-radius: var(--raio-pequeno);
    background: #fff;
  }

  .rodape__apoio-rotulo {
    font-family: var(--fonte-titulo);
    font-size: 0.7rem;
    font-weight: 800;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: var(--cor-tinta);
    /* Os logos ao lado tem deslocamento vertical; alinha o rotulo a eles. */
    transform: translateY(2px);
  }

  .rodape__apoio-marcas {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
    gap: var(--espaco-2);
    list-style: none;
    margin: 0;
    padding: 0;
  }

  /* Arrasto, selecao e menu de contexto bloqueados sobre os logos de apoio. */
  .rodape__apoio-marcas img {
    display: block;
    width: auto;
    pointer-events: none;
    user-select: none;
    -webkit-user-drag: none;
    -webkit-touch-callout: none;
  }

  /*
   * Altura calibrada no olho: cada logo tem proporcao e peso proprios, entao
   * altura igual nao da tamanho visual igual. Os deslocamentos verticais
   * corrigem logos cuja arte pende para um lado. A chave vem do nome do logo.
   */
  .rodape__apoio-item--fapesq img {
    height: 14px;
    transform: translateY(3px);
  }

  .rodape__apoio-item--tecnova img {
    height: 17px;
    transform: translateY(7px);
  }

  .rodape__apoio-item--finep img {
    height: 17px;
  }

  .rodape__apoio-item--governo img {
    height: 17px;
  }

  .rodape__base {
    justify-content: center;
  }

  @media (min-width: 768px) {
    .rodape__grade {
      grid-template-columns: 1.5fr 1fr 1.2fr 1fr;
      /* Linha justa entre a marca e o card de apoio; colunas com folga normal. */
      column-gap: var(--espaco-6);
      row-gap: 2px;
      align-items: start;
      padding-block: var(--espaco-7) var(--espaco-6);
    }

    .rodape__descricao {
      font-size: 0.92rem;
      line-height: 1.6;
      margin: var(--espaco-4) 0;
    }

    .lojista {
      border-top: 0;
      padding-top: 0;
    }

    /*
     * No desktop o card ocupa apenas a coluna 1, abaixo da marca e da
     * descricao. O tamanho compacto ja vem da base; aqui so posiciona.
     */
    .rodape__apoio-linha {
      grid-column: 1 / 2;
      grid-row: 2;
      justify-content: flex-start;
    }
  }
</style>
